import { APIModel } from './api-model.model'

export class APICarrierPolicy extends APIModel {
    carrierId: number;
    carrierPolicyId: number;
    carrierPolicyType: string;
    carrierPolicyDescription: string;
    carrierPolicyValue: number;
    carrierPolicyEnabled: number;

    constructor (params: {
        id?: number;
        createdAt?: string;
        updatedAt?: string;
        deletedAt?: string;
        carrierId: number;
        carrierPolicyId: number;
        carrierPolicyType: string;
        carrierPolicyDescription: string;
        carrierPolicyValue: number;
        carrierPolicyEnabled: number;
    }) {
        const { id, createdAt, updatedAt, deletedAt } = params
        super({ id, createdAt, updatedAt, deletedAt })

        this.carrierId = params.carrierId
        this.carrierPolicyId = params.carrierPolicyId
        this.carrierPolicyType = params.carrierPolicyType
        this.carrierPolicyDescription = params.carrierPolicyDescription
        this.carrierPolicyValue = params.carrierPolicyValue
        this.carrierPolicyEnabled = params.carrierPolicyEnabled ? 1 : 0
    }
}
